import { isIncomingSwish, normalizeRulePattern } from '@budgie/shared';

export type ImportedTxnForRuleApplication = {
  id: string;
  description: string;
  /** Öre; incoming Swish rows are never categorised by a rule */
  amount?: number;
  isDuplicate: boolean;
};

export type TxnOverride = {
  categoryId: string | null;
  skip: boolean;
  createRule: boolean;
  isTransfer: boolean;
  createTransferRule: boolean;
  rulePattern: string | null;
  isManualOverride: boolean;
  autoAppliedRulePattern: string | null;
};

export function applyRuleToImportBatch(args: {
  sourceTransactionId: string;
  transactions: ImportedTxnForRuleApplication[];
  overrides: Record<string, TxnOverride>;
  pattern: string;
  categoryId: string;
}): {
  overrides: Record<string, TxnOverride>;
  appliedCount: number;
  appliedTransactionIds: string[];
} {
  const normalizedPattern = normalizeRulePattern(args.pattern);
  if (!normalizedPattern || normalizedPattern.length < 3) {
    return {
      overrides: args.overrides,
      appliedCount: 0,
      appliedTransactionIds: [],
    };
  }

  const nextOverrides = { ...args.overrides };
  const appliedTransactionIds: string[] = [];

  for (const transaction of args.transactions) {
    if (transaction.id === args.sourceTransactionId) continue;
    if (
      transaction.amount != null &&
      isIncomingSwish(transaction.description, transaction.amount)
    ) {
      continue;
    }

    const normalizedDescription = normalizeRulePattern(transaction.description);
    if (!normalizedDescription.includes(normalizedPattern)) continue;

    const existing = nextOverrides[transaction.id];
    if (!existing) continue;
    if (
      transaction.isDuplicate ||
      existing.skip ||
      existing.isTransfer ||
      existing.isManualOverride
    ) {
      continue;
    }
    if (existing.categoryId && !existing.autoAppliedRulePattern) {
      continue;
    }
    if (
      existing.categoryId === args.categoryId &&
      existing.autoAppliedRulePattern === args.pattern
    ) {
      continue;
    }

    nextOverrides[transaction.id] = {
      ...existing,
      categoryId: args.categoryId,
      autoAppliedRulePattern: args.pattern,
      isManualOverride: false,
    };
    appliedTransactionIds.push(transaction.id);
  }

  return {
    overrides: nextOverrides,
    appliedCount: appliedTransactionIds.length,
    appliedTransactionIds,
  };
}
